// extracted by mini-css-extract-plugin
export default {"homeTitle":"c-a_fF","homeTitle_styleDefault":"c-a_fG","homeTitle_styleRed":"c-a_fH"};